/**
 * Inventory service - uses product API for inventory views.
 * Supports planned inventory, parts view, and quantity on hand.
 * Backend may expose dedicated inventory endpoints; extend this service as needed.
 */
export default (https) => ({
  async getList(params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');
    const response = await https.get(`/inventories?${queryString}`);
    return response.data;
  },
  async getInventorLogy(params = []) {
    const paramsWithType = [...params, { key: 'type', value: 'finishgood' }];
    return this.getList(paramsWithType);
  },
  async getParts(params = []) {
    const paramsWithType = [...params, { key: 'type', value: 'parts' }];
    return this.getList(paramsWithType);
  },
  async getQuantityOnHand(params = []) {
    return this.getList(params);
  },
  async bulkUpdateQuantity(items) {
    const promises = items.map(({ id, quantity_on_hand }) =>
      https.post(`/products/${id}`, { quantity_on_hand })
    );
    const results = await Promise.all(promises);
    return results.map(r => r.data);
  },
  async updateQuantity(id, payload) {
    const response = await https.post(`/products/${id}`, payload);
    return response.data;
  },
  async import(file) {
    const formData = new FormData();
    formData.append('file', file);
    const response = await https.post(`/products/import`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },
});
